/* eslint-disable no-underscore-dangle */
import parseRoute from '../utils/parseRoute.ts';
import type { PLPRoute } from '@/domain/Route.ts';
import { getRemoteData } from './Remote.ts';
import {
  productTypePathToProductType,
  type ProductTechnology
} from '@/domain/Product.ts';
import ProductListHeroBanner, {
  type ProductListHeroBannerProps
} from './ProductListHeroBanner.tsx';
import Loader from '../components/containers/Loader/Loader.tsx';

async function load() {
  const route: PLPRoute = window?.__pb__?.user
    ? buildPBRoute(window?.__pb__)
    : parseRoute(globalThis?.location?.href);

  const remoteData = await getRemoteData(route);

  return {
    route,
    ...remoteData
  };
}

export default function ProductListHeroBannerLoader() {
  return (
    <Loader<ProductListHeroBannerProps>
      load={load}
      renderSkeleton={() => <ProductListHeroBanner.Skeleton />}
    >
      {({ config, route }) => (
        <ProductListHeroBanner config={config} route={route} />
      )}
    </Loader>
  );
}

function buildPBRoute(pb: Window['__pb__']): PLPRoute {
  const { user } = pb!;
  if (!user) return {} as PLPRoute;
  return {
    market: user.market,
    channel: user.channel,
    technology: user.technology as ProductTechnology,
    locale: user.language,
    productTypePath: user.productList,
    productType: productTypePathToProductType(user.productList),
    inFavorites: false,
    inPLP: false
  };
}
